import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";

import { picklistsSelectors } from "store/selectors";

const PRINCIPAL_INVESTIGATOR = "principal-investigator";

export const useRoleFinder = ({ config, setRole }) => {
	const [ roleOptions, setRoleOptions ] = useState([]);
	const { options } = useSelector(picklistsSelectors.researchTeamRoles);

	useEffect(() => {
		const items = options.filter(({ id, active }) => id === config.value || active )
			.map(item => {
				return {
					key: item.id,
					value: item.id,
					text: item.label,
					role: item,
					content: (
						<div className={`optionContent ${!item.active ? "hidden" : ""}`}>
							<span>{item.label}</span>
						</div>
					),
				};
			});

		setRoleOptions(items);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ options, config.value ]);

	const onSelectRole = selectedOptions => {
		setRole(selectedOptions[0]?.value ?? null);
	};

	const getRoles = roles => {
		const { hasPrincipalInvestigator } = config;

		const filterPI = () => roles.filter(({ key }) => key !== PRINCIPAL_INVESTIGATOR);

		return isNonEmptyArray(roles) && hasPrincipalInvestigator && config.value !== PRINCIPAL_INVESTIGATOR
			? filterPI()
			: [ ...roles ];
	};

	return {
		preselectedOptions: getRoles(roleOptions),
		searchChange: onSelectRole,
		ariaLabel: "Role",
	};
};
